module.exports = __webpack_public_path__ + "img/kristal.efe96a15.png";